export const OldOnboarding = "NewDcgAccount";
export const DcgAutomation = "dcg-onboarding";